import Place from "./Place";
import people, {currentPlayer} from "../people/people";
import Image from "../../features/Image";
import images from "../images";
import conditions from "../conditions";
import missions from "../missions";
import places from "./places";
import variables from "../variables";
import Name from "../../features/Name";
import i18next from "i18next";

const missionStyle = {color: "orange"};

const pillsMenu = new Place("pillsMenu", "Just a Pack of Pills", "pillsPack", "The secret place where the magic pills lie.");
pillsMenu.addDefaultLink(
    "other.places.pillsMenu.pills", "story.pillsReadInstruction", null, ()=>(conditions.missions.instructionsActive()), missionStyle);
pillsMenu.addDefaultLink("other.places.pillsMenu.pills", "game.pillsInstruction", null, ()=>(conditions.missions.instructionsFin()))
pillsMenu.addDefaultLink("other.places.pillsMenu.back", "", () => {currentPlayer.goTo("table")});
pillsMenu.getImage = function () {return <Image src={images.other[this.image]}/>};

const bedMenu = new Place("bedMenu", "Your Bed", "", "Your and your wife bed, on which you can lie during the day and sleep at night.");
bedMenu.getImage = () => (<Image src={images.places.homes.bed}/>);
bedMenu.addDefaultLink("other.places.bedMenu.sleep", "game.sleep", null, ()=>(conditions.isNight()));
bedMenu.addDefaultLink("other.places.bedMenu.nap", "game.nap", null, ()=>(conditions.isDay()));
bedMenu.addDefaultLink("other.places.bedMenu.back", "", ()=>{currentPlayer.goTo(places.homeBedroom.id)});

const wifeMenu = new Place("wifeMenu");
wifeMenu.getCaption = () => (<h1><Name who={people.wife} noStyle/></h1>);
wifeMenu.getImage = () => (<Image src={people.wife.occupations.get().getImage()}/>);
wifeMenu.getDescription = () => (`${people.wife.getName()} ${i18next.t(people.wife.occupations.get().caption)} now.`);
wifeMenu.addBeforeEnteringCallback(()=>(people.wife.occupations.current.id === people.wife.occupations.officeJob.id), "game.courierJobOfficeWifeDoNotDisturb");
wifeMenu.addDefaultLink("other.places.wifeMenu.chat", "wife.chat", null, ()=>(conditions.wifeCanTalk()));
wifeMenu.addDefaultLink("other.places.wifeMenu.howSheFeels", "wife.howSheFeels", null, ()=>(conditions.wifeCanTalk() && missions.initCorruption_01.tasks.treatWifePill_01.finished));
wifeMenu.addDefaultLink("other.places.wifeMenu.makeOut", "wife.makeOut", null, ()=>(conditions.wifeCanTalk()));
wifeMenu.addDefaultLink("other.places.wifeMenu.bathTogether", "wife.bathTogether", null, ()=>(conditions.wifeInBathroom()));
wifeMenu.addDefaultLink(
    "other.places.wifeMenu.getWifeInfoAboutDrink", "story.getWifeInfoAboutDrink", null, ()=>(conditions.getInfoAboutDrink_01CanBeShown()), missionStyle);
wifeMenu.addDefaultLink("other.places.wifeMenu.tellWifeAboutJobInOffice","story.tellWifeAboutJobInOffice", null, ()=>(conditions.missions.tellWifeAboutJobInOfficeIsReady()), missionStyle);
wifeMenu.addDefaultLink("other.places.wifeMenu.checkHerAss", "wife.checkHerAss", null, ()=>(conditions.wifeIsSleeping()));
wifeMenu.addDefaultLink("other.places.wifeMenu.wifeSexMenu", "", ()=>{currentPlayer.goTo(places.wifeSexMenu.id)}, ()=>(conditions.wifeCanTalk()));
wifeMenu.addDefaultLink("other.places.wifeMenu.back", "", ()=>{currentPlayer.goTo(people.wife.where)});

const wifeDressUpMenu = new Place("wifeDressUpMenu", "Wardrobe", "wardrobe", "You need to dress up before going out.");
wifeDressUpMenu.getImage = function () {return <Image src={images.other[this.image]}/>};
wifeDressUpMenu.addDefaultLink("other.places.wifeDressUpMenu.jeans", "", ()=>{
    variables.wife.isDressedUp = true;
    currentPlayer.goTo(places.homeMain.id);
});
wifeDressUpMenu.addDefaultLink("other.places.wifeDressUpMenu.back", "", ()=>{currentPlayer.goTo(places.homeBedroom.id)});

const wifeSexMenu = new Place("wifeSexMenu");
wifeSexMenu.getCaption = () => (<h1><Name who={people.wife} noStyle/></h1>);
wifeSexMenu.getImage = () => (<Image src={people.wife.occupations.get().getImage()}/>);
wifeSexMenu.getDescription = () => ("");
wifeSexMenu.addDefaultLink("other.places.wifeSexMenu.handsJob", "wife.handsJob", null);
wifeSexMenu.addDefaultLink("other.places.wifeSexMenu.blowjob", "wife.blowjob", null);
wifeSexMenu.addDefaultLink("other.places.wifeSexMenu.sex", "wife.sex", null);
wifeSexMenu.addDefaultLink("other.places.wifeSexMenu.analSex", "wife.analSex", null);
wifeSexMenu.addDefaultLink("other.places.wifeSexMenu.back", "", ()=>{currentPlayer.goTo(places.wifeMenu.id)});

const rentMenu = new Place("rentMenu", "Rent payment", "", "It was time to pay the rent, so you woke up and immediately went to the owner of the apartment.");
rentMenu.getImage = () => (<Image src={images.places.homes.apartments01.homeMain}/>);
rentMenu.addDefaultLink("other.places.rentMenu.rentPayment", "story.rentPayment");


const menus = {
    pillsMenu,
    bedMenu,
    wifeMenu,
    wifeSexMenu,
    rentMenu,
    wifeDressUpMenu
}

export default menus;